import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_AGGREGATE_DATA, GET_COLLECTION_DATA} from '../../../api';
import $ from "jquery";
import cogoToast from "cogo-toast";
import moment from "moment";
import {capitalize} from "../../../utils/capitalize";
import {liveAccount, payout, getGrantReport, topUpWallet, application, grant} from "../../../api/app";
import 'react-quill/dist/quill.snow.css';
import networks from "../../../data/networks.json";
import formatNumber from "../../../utils/formatNumber";
import {useSelector} from "react-redux";

const searchableFields = [
    { field: 'user.name', isNumeric: false },
    { field: 'reg_number', isNumeric: true },
    { field: 'user.mobile_number', isNumeric: true },
    { field: 'user.id_number', isNumeric: false },
    { field: 'user.location.provincial.name', isNumeric: false }
];

let filter = {};
let grant_id = null;

const Grant = () => {

    document.title = "Grant";

    const {province, districts, constituencies, wards} = useSelector(state => state.app?.administrative);
    const [provincialSelected, setProvincialSelected] = useState(null);
    const [districtSelected, setDistrictSelected] = useState(null);
    const [constituencySelected, setConstituencySelected] = useState(null);

    const token = localStorage.getItem('jwtToken');
    const [editForm, setEditForm] = useState(false);
    const [id, setId] = useState(null);
    const [type, setType] = useState(null);
    const [stateReady, setStateReady] = useState(false);
    const [reset, setReset] = useState(new Date().getTime());
    const [network, setNetwork] = useState([]);

    useEffect(() => {
        liveAccount().then((response) => {
            if(!response.error) {
                $('#live-balance').text(formatNumber(response.payload.balance));
                $('#total-balance').text(`K${formatNumber(response.payload.wallet, "digit")}`);
                $('#total-balance-amount').text(`Available: K${formatNumber(response.payload.balance - response.payload.wallet)}`);
            }
        });
    }, [reset]);

    useEffect(() => {
        getGrantReport().then((response) => {
            if(!response.error) {
                $('#total-grant').text(formatNumber(response.payload.total.count, "digit"));
                $('#total-grant-amount').text(`Amount: K${formatNumber(response.payload.total.amount, "digit")}`);

                $('#total-pending').text(formatNumber(response.payload.pending.count, "digit"));
                $('#total-pending-amount').text(`Amount: K${formatNumber(response.payload.pending.amount, "digit")}`);

                $('#total-disbursed-amount').text(`Amount: K${formatNumber(response.payload.disbursement.total, "digit")}`);
                $('#total-disbursed').text(formatNumber(response.payload.disbursement.count, "digit"));
            }
        });
    }, [reset]);

    useEffect(() => {
        let table = $('#fund').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Grant Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "grant",
                        searchableFields,
                        filter,
                        pageSize: data.start,
                        format: 'json',
                        populate: [
                            {
                                path: "user",
                                model: "user"
                            }
                        ],
                        sort: { _id: -1 },
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `<a href="#/membership/${data.user._id}" target="_blank" class="text-dark">${capitalize(data.user?.name) || 'No data'}</a>`
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return `K${formatNumber(data.amount)}`;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data?.business_type);
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return {
                            "pending" : `<span class="badge badge-secondary tx-white">Pending</span>`,
                            "active" : `<span class="badge badge-success tx-white">Approved</span>`,
                            "approved" : `<span class="badge badge-success tx-white">Approved</span>`,
                            "rejected" : `<span class="badge badge-danger tx-white">Rejected</span>`
                        }[data.status];
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only">${data.approved ? `<span class="nav-link approve-fund">--- No Action ---</span>`  : `<a href="#" class="nav-link topup-wallet"><i class="fa fa-arrow-up"></i> TopUp Wallet</a> <a href="#" class="nav-link reject-grant"><i class="fa fa-ban"></i> Reject</a>` }</nav>`
                    },
                    "targets": 5
                }
            ]
        });

        $('#fund tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        table.on('click', '.approve-fund', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();
            setId(extract_td.raw._id);
            setType("grant");
            $('#disbursement-amount').val(extract_td?.raw?.amount);
            $('#account-number').val(parseInt(extract_td.raw?.user?.mobile_number));

            $('#payout_form').parsley();

            $("#modalPayout").modal("show");
        });

        table.on('click', '.reject-grant', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();
            grant_id = extract_td.raw._id;

            $('#remark_form').parsley();
            $("#modalRemark").modal("show");
        });

        table.on('click', '.topup-wallet', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();
            setId(extract_td.raw._id);
            setType("grant");

            $("#deposit_form").parsley();
            $("#modalDeposit").modal("show");
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Description:</td>' +
                '<td>' +
                `${d.raw.description}` +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Contact Number:</td>' +
                '<td>' +
                `${d.raw.user.mobile_number}` +
                '</td>' +
                '</tr>' +
                '<td>Reg Number:</td>' +
                '<td>' +
                `${d.raw.req_number}` +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Date:</td>' +
                '<td>' +
                `${moment(d.raw?.createdAt).format("Do MMM, YYYY HH:mm")}` +
                '</td>' +
                '</tr>' +
                '</table>'
            );
        }

        return () => {
            table.destroy();
        }

    }, []);

    const onAreaSelected = (data) => {
        const id = data?._id || null;
        const name = data?.name || "All Provinces";

        filter = id ? { "admin_level.provincial": `ObjectId(${id})` } : {};

        $("#provincial-name").text(name);
        setProvincialSelected(id);

        $("#district-name").text("District");
        setConstituencySelected(null);

        $("#constituency-name").text("Constituency");
        setConstituencySelected(null);

        $('#fund').DataTable().ajax.reload();
    };

    const onDistrictSelected = (data) => {
        filter = {"admin_level.district": `ObjectId(${data._id})`};

        $("#district-name").text(data.name);
        setDistrictSelected(data._id);

        $("#constituency-name").text("Constituency");
        setConstituencySelected(null);

        $('#fund').DataTable().ajax.reload();
    }

    const onConstituencySelected = (data) => {
        filter = {"admin_level.constituency": `ObjectId(${data._id})`};
        $("#constituency-name").text(data.name);
        setConstituencySelected(data._id);

        $('#fund').DataTable().ajax.reload();
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handlePayment = (e) => {
        $("#label-number").text(e.target.value === "momo" ? "Mobile Number" : "Account Number");
        setNetwork(networks.filter((item) => item.type === e.target.value));
        $("#network").val('');
    }

    const handleDisbursement = (e) => {
        e.preventDefault();

        let amount = $('#disbursement-amount').val();
        let email = $('#email').val();

        setStateReady(true);

        let data = {
            id,
            amount,
            email,
            account_number: $('#account-number').val(),
            network: $('#network').val(),
            gateway: $('#gateway').val(),
            doc: type
        };

        payout("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Disbursement successfully sent.", {position: "top-right", hideAfter: 5});
                resetForm("modalPayout", "payout_form");
                reloadTable("fund");
                setReset(new Date().getTime());
            }
        });
    }

    const handleTopUpWallet = (e) => {
        e.preventDefault();

        let amount = $('#amount').val();

        setStateReady(true);

        let data = {
            id,
            amount,
            doc: type
        };

        topUpWallet("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success(result.payload, {position: "top-right", hideAfter: 5});
                resetForm("modalDeposit", "deposit_form");
                reloadTable("fund");
                setReset(new Date().getTime());
            }
        });
    }

    const handleStatusChange = (data, text) => {
        const status = $("#tx-status");
        const dt_fund = $('#fund');
        if(data === "all") {
            status.text("Select Status");
            if (filter.hasOwnProperty("status")) {
                delete filter["status"];
                dt_fund.DataTable().ajax.reload();
            }
            return false;
        }

        filter = Object.assign(filter, {status: data});
        status.text(text);
        dt_fund.DataTable().ajax.reload();
    }

    const handleTypeChange = (data, text) => {
        const status = $("#tx-type");
        const dt_fund = $('#fund');
        if(data === "all") {
            status.text("Select Type");
            if (filter.hasOwnProperty("business_type")) {
                delete filter["business_type"];
                dt_fund.DataTable().ajax.reload();
            }
            return false;
        }

        filter = Object.assign(filter, {business_type: data});
        status.text(text);
        dt_fund.DataTable().ajax.reload();
    }

    const handleRemarkSubmit = () => {
        setStateReady(true);

        const options = {
            position: "top-right",
            hideAfter: 0
        };

        let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

        let payload = {
            remark: $("#remark").val(),
            id: grant_id,
            status: "rejected"
        }

        grant("put", payload).then((result) => {
            setStateReady(false);
            hide();
            if(!result.error) {
                resetForm("modalRemark", "remark_form");
                setReset(new Date().getTime());
                $('#fund').DataTable().ajax.reload();
                cogoToast.success("Grant successfully rejected.", {position: "top-right"});
            }
        });
    }

    const reloadTable = (id) => {
        $(`#${id}`).DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div className="media align-items-center">
                        <img src="assets/img/logo.svg" className="ht-40 img-fluid" alt="logo"/>
                        <div className="media-body mg-l-10 my-auto">
                            <h6 className="tx-10 tx-lg-12 tx-medium tx-uppercase tx-spacing-1 tx-gray-800 mg-b-5">Live Account <span className="tx-normal tx-color-03">(ZMW)</span></h6>
                            <div className="d-flex align-items-baseline">
                                <h2 className="tx-13 tx-lg-24 tx-bold tx-rubik tx-spacing--2 lh-2 mg-b-0" id="live-balance">0</h2>
                            </div>
                        </div>
                    </div>
                    <div className="d-none d-md-block">
                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-primary btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="provincial-name">All Provinces</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    <a href="#" onClick={(e) => {e.preventDefault(); onAreaSelected(null)}} className="dropdown-item">All Provinces</a>
                                    {province?.map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onAreaSelected(item)}} className="dropdown-item text-capitalize">{item.name}</a>
                                        )
                                    })}
                                </div>
                            </span>

                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-info btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="district-name">District</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    {provincialSelected ? districts?.filter((item) => item.administrative === provincialSelected).map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onDistrictSelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>
                                        )
                                    }) : <span className="dropdown-item">Select Province First</span>}
                                </div>
                            </span>

                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-secondary btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="constituency-name">Constituency</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    {districtSelected ? constituencies?.filter((item) => item.district === districtSelected).map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onConstituencySelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>
                                        )
                                    }) : <span className="dropdown-item">Select District First</span>}
                                </div>
                            </span>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-3">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Grant</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-grant" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-grant-amount" className="tx-12 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-purple tx-semibold mg-b-8">Total Pending</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-pending" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-pending-amount" className="tx-12 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-success tx-semibold mg-b-8">Wallet Balance</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-balance" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-balance-amount" className="tx-12 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-danger tx-semibold mg-b-8">Total Disbursement</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-disbursed" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-disbursed-amount" className="tx-12 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-md-12 mg-t-10">
                        <div className="card card-crypto">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Grant List</h6>
                                <div className="d-flex tx-18 align-items-center">
                                    <div className="dropdown mg-r-10">
                                        <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-type">Select Type</span></a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleTypeChange.bind(null, 'all')}>All</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleTypeChange.bind(null, "company", "Company")}>Company</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleTypeChange.bind(null, "ngo", "NGO")}>NGO</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleTypeChange.bind(null, "individual", "Individual")}>Individual</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleTypeChange.bind(null, "co-operative", "Co-Operative")}>Co-Operative</a>
                                        </div>
                                    </div>

                                    <div className="dropdown mg-r-10">
                                        <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-status">Select Status</span></a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, 'all')}>All</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "pending", "Pending")}>Pending</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "active", "Approved")}>Approved</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "rejected", "Rejected")}>Rejected</a>
                                        </div>
                                    </div>

                                    <a href="#" onClick={(e) => {
                                        e.preventDefault(); $('#fund').DataTable().ajax.reload();
                                        setReset(new Date().getTime());
                                    }} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <div id="general" className="tab-pane fade active show">
                                    <table id="fund" className="table">
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th className="wd-20p">Name</th>
                                            <th className="wd-20p">Fund</th>
                                            <th className="wd-20p">Type</th>
                                            <th className="wd-20p">Status</th>
                                            <th className="wd-20p">Action</th>
                                        </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalPayout" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalPayout", "payout_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit Payout" : "Add Payout"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} payout information.</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="payout_form" className="parsley-style-1" onSubmit={handleDisbursement.bind()}>
                                    <div id="emailWrapper" className="form-group parsley-input">
                                        <label>Email Address</label>
                                        <input id="email" type="email" className="form-control"
                                               placeholder="Enter email address"
                                               autoComplete="none"
                                               data-parsley-class-handler="#emailWrapper"
                                               required
                                        />
                                    </div>

                                    <div id="typeWrapper" className="form-group parsley-input">
                                        <label>Mode of Payment<span className="tx-danger">*</span></label>
                                        <select className="custom-select" id="gateway" required onChange={handlePayment.bind()}>
                                            <option value="" disabled selected>Select</option>
                                            <option value="momo">Mobile Money</option>
                                            <option value="bank">Bank</option>
                                        </select>
                                    </div>

                                    <div id="networkWrapper" className="form-group parsley-input">
                                        <label>Network<span className="tx-danger">*</span></label>
                                        <select className="custom-select" id="network" required>
                                            <option value="" disabled selected>Select</option>
                                            {network.slice().sort((a, b) => a.name.localeCompare(b.name)).map((item, index) => (
                                                <option key={index} value={item.value}>{item.name}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div id="accountNumberWrapper" className="form-group parsley-input">
                                        <label id="label-number">Account Number</label>
                                        <input id="account-number" type="number" className="form-control"
                                               placeholder="Enter number"
                                               autoComplete="none"
                                               data-parsley-class-handler="#accountNumberWrapper"
                                               required
                                        />
                                    </div>

                                    <div id="amountWrapper" className="form-group parsley-input">
                                        <label>Amount<span className="tx-danger">*</span></label>
                                        <input id="disbursement-amount" type="number" className="form-control"
                                               placeholder="Enter amount"
                                               autoComplete="none"
                                               step="0.01"
                                               data-parsley-class-handler="#amountWrapper"
                                               required/>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-success btn-block"><span
                                        className="spinner-border spinner-border-sm mg-r-10" role="status"
                                        aria-hidden="true"/>Please Wait</button> : editForm ?
                                        <button className="btn btn-success btn-block">Update Payout</button> :
                                        <button className="btn btn-success btn-block">Add Payout</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalDeposit" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalDeposit", "deposit_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Top Up Wallet</h4><p className="tx-13 tx-color-02 mg-b-0">Deposit into account balance</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="deposit_form" className="parsley-style-1" onSubmit={handleTopUpWallet.bind()}>
                                    <div id="amountWrapper" className="form-group parsley-input">
                                        <label>Amount<span className="tx-danger">*</span></label>
                                        <input id="amount" type="number" className="form-control"
                                               placeholder="Enter amount"
                                               autoComplete="none"
                                               data-parsley-class-handler="#amountWrapper" required/>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-primary btn-block">Deposit</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalRemark" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalRemark", "remark_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Rejection</h4><p className="tx-13 tx-color-02 mg-b-0">Give reason why you rejected this application.</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="remark_form" className="parsley-style-1" onSubmit={handleRemarkSubmit.bind()}>
                                    <div id="remarkWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Remark<span className="tx-danger">*</span></label>
                                        <textarea id="remark" rows="10" className="form-control"
                                                  placeholder="Enter remark or give reason"
                                                  maxLength={180}
                                                  data-parsley-class-handler="#remarkWrapper" required/>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-primary btn-block">Submit</button> }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Grant;
